import { Component } from '@angular/core';
import { AuthenticationService } from '../../../service/authentication.service';
import { ApiService } from '../../../service/api.service';

@Component({
  selector: 'app-dashboard2',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent2 {
  links = []
  url
  urlall = "";
  activeLink
  systemsArray
  constructor(
    private authenticationService: AuthenticationService,
    public dataStorageService: ApiService,
  ) { }

  ngOnInit() {
    var user = this.authenticationService.user;
    var me = this;
    if (user.profile == "SuperAdmin") {
      me.dataStorageService.getBodyList().subscribe(function (v) {
        v.push('All');
        v.forEach(function (val) {
          me.links.push({ "name": val, "src": "https://sosimperium.multiutilitydelgarda.eu:3000/d/K6AHwXqGk/alarms?orgId=1&from=now-7d&to=now&kiosk&var-body=" + val });
        });
      });
      me.urlall = "https://sosimperium.multiutilitydelgarda.eu:3000/d/K6AHwXqGk/alarms?orgId=1&from=now-7d&to=now&kiosk&var-body=All";

    } else {
      me.links.push({ "name": user.bodyid, "src": "https://sosimperium.multiutilitydelgarda.eu:3000/d/K6AHwXqGk/alarms?orgId=1&from=now-7d&to=now&kiosk&var-body=" + user.bodyid });
      me.urlall = me.links[0].src

    }
    me.activeLink = me.links[0];
    me.updateurl(me.links[0].src);
  };

  updateurl(url) {
    this.url = url
  }
}
